import { insights, getSearchToken } from '../../services/algoliaService'
import localStorageCache from '../../utils/localStorageCache'
import { SEARCH_CONVERSION } from '../../libs/config'

module.exports = async function () {
  const content = localStorageCache.getItemAndRemove(SEARCH_CONVERSION) as {objectIDs: string[], positions: number[]}
  if (!content) return

  const CONVERSION_TIME = 30000

  getSearchToken(data => {
    insights('init', {
      appId: data.client_id,
      apiKey: data.token
    })

    setTimeout(function recordConversion () {
      insights('convertedObjectIDsAfterSearch', {
        ...content,
        eventName: `Search item read after ${CONVERSION_TIME / 1000}s`
      })
    }, CONVERSION_TIME)
  })
}
